<script lang="ts">
	export let dark = false;
</script>

<td class={`table-cell ${$$props.class}`} class:dark on:click>
	<slot />
</td>

<style lang="scss">
	@import 'tableCell';
</style>
